<template>
  <div :class="classes" class="asd20-search-field">
    <asd20-icon v-if="large" name="search" size="md" />
    <asd20-icon v-else name="search" size="sm" />

    <label for="asd20-search">Search</label>
    <input
      id="asd20-search"
      :value="value"
      type="search"
      placeholder="Search"
      name="asd20-search"
      autocomplete="off"
      @input="$emit('input', $event.target.value)"
    />
    <div v-if="extra || !!$slots.default" class="asd20-search-field__extra">
      {{ extra }}<slot />
    </div>
  </div>
</template>

<script>
import Asd20Icon from '../../atoms/Asd20Icon'

export default {
  name: 'Asd20SearchField',
  components: { Asd20Icon },
  props: {
    value: { type: String, default: '' },
    extra: { type: String, default: '' },
    large: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return {
        'asd20-search-field--large': this.large,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-search-field {
  position: relative;
  display: flex;
  align-items: center;
  // flex-shrink: 0;

  label {
    position: absolute;
    height: 1px;
    width: 1px;
    clip: rect(1px 1px 1px 1px); // IE 6 and 7
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: polygon(0px 0px, 0px 0px, 0px 0px);
    -webkit-clip-path: polygon(0px 0px, 0px 0px, 0px 0px);
    overflow: hidden !important;
  }

  & > .asd20-icon {
    position: relative;
    // outline: 1px solid red;
    width: space(1);
    margin-left: space(0.5);
    margin-right: space(-1.5);
    pointer-events: none;
  }

  input {
    -webkit-appearance: none !important;
    display: block;
    width: 100%;
    flex-grow: 1;
    padding: 0 space(0.25) 0 space(1.625);
    margin: 0;
    border: none;
    border-radius: 0;
    // outline: 1px solid red;
    // font-size: space(0.75);
    font-size: space(0.625);
    line-height: 1;
    height: space(2);
    background: white;
    transition: background asd20-speed(1) ease;

    &::-webkit-search-decoration {
      -webkit-appearance: none !important;
    }

    &:focus {
      // outline: none;
      box-shadow: 0 0 0 5px var(--color__accent-t70) inset;
    }

    &::-webkit-input-placeholder {
      opacity: 1;
      color: var(--color__secondary-t50);
      // font-size: space(0.75);
    }
    &::-moz-placeholder {
      opacity: 1;
      color: var(--color__primary-t50);
    }
    &:-ms-input-placeholder {
      opacity: 1;
      color: var(--color__primary-t50);
    }
    &:-moz-placeholder {
      opacity: 1;
      color: var(--color__primary-t50);
    }
    &:focus + .asd20-search-field__extra {
      background: var(--website-page__alternate-background-t40);
    }
  }

  .asd20-search-field__extra {
    transition: background asd20-speed(1) ease;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    white-space: nowrap;
    color: var(--color__primary-t50);
    box-shadow: -1px 0 0 0 var(--color__tertiary);
  }
  &--large {
    & > .asd20-icon {
      width: space(1.5);
      height: space(1.5);
      margin: 0;
    }
    input {
      margin-left: space(0);
      font-size: 2rem;
      line-height: 1.5;
      padding: 0 space(0.25) 0 space(0.5);
      height: space(3);
    }
  }
}
</style>
